<app-nav></app-nav>
<app-modal-view></app-modal-view>
<main>
  <div class="siteUpdated" [ngClass]="{ 'hide': !lastUpdate.current() }">Refresh site to see updates</div>
  <router-outlet />
</main>
<app-footer></app-footer>